import type { UseQueryResult } from "@tanstack/react-query";

import { fetchMergeGate } from "./api";
import type { MergeGateResponse } from "./api";
import { useOrgScopedQuery } from "../../query/scope";

// Снимок гейта слияния. Каждый запрос идёт в хостинг, поэтому хук
// живёт только пока смонтирован баннер, а повторов при ошибке нет:
// отказ показывается человеку, перечитать можно кнопкой.
export function useMergeGate(
  taskId: string,
): UseQueryResult<MergeGateResponse, Error> {
  return useOrgScopedQuery({
    key: ["merge-gate", taskId],
    queryFn: () => fetchMergeGate(taskId),
    retry: false,
  });
}
